<div class="protean-menu">
  <div class="container-fluid protean-top-bar" style="overflow-x: auto; scrollbar-width: none;">
    <a class="protean-logo" [routerLink]="'/devices'">
      <div class="shine-wrapper">
        <img src="assets/images/cliQTest.svg" alt="Protean Logo" class="logo-img" />
      </div>
      <span class="logo-text">Protean</span>
    </a>
    <div class="language">
      <ul class="nav protean-nav unselectable">
        @for (menu of menuItems; track menu) {
          <li>
            <!-- [ngClass]="currentActiveTab == menu.tabRoute ? 'current' : ''" , [routerLinkActiveOptions]="{exact: false}" , routerLinkActive="current"  , needsValidation(menu.tabRoute) ? null :  -->
            <a [routerLink]="menu.tabRoute" [ngClass]="currentActiveTab == menu.tabRoute ? 'current' : ''" (click)="onTabClick(menu.tabRoute)">
              <span class="{{menu.iconClass}}"></span>
              <span id="menuLabel">{{menu.label | translate}}</span>
            </a>
          </li>
        }
      </ul>
    </div>
    <ul class="nav protean-nav protean-feedback" style="margin-left: auto;">
      <!-- <li class="protean-nav-web-native-button">
      <div class="btn-group">
        <button class="btn btn-sm btn-default-outline" type="button">Web</button>
        <button class="btn btn-sm btn-default-outline" type="button">Native</button>
      </div>
    </li> -->
    <li class="protean-nav-web-native-button">
      <button class="btn btn-sm btn-default-outline" (click)="mailToProteanSupport()" type="button"><i
        class="fa fa-envelope"></i><span>&nbsp; {{"Contact Support" | translate}} </span></button>
      </li>
      <li class="protean-nav-web-native-button">
        <button class="btn btn-sm btn-default-outline" type="button" (click)="logout()"><i
          class="fa fa-sign-out"></i><span>&nbsp; {{"Logout" | translate}} </span></button>
        </li>
      </ul>
    </div>
  </div>
  <ng-template #alerttemplate let-modal>
    <div class="modal-body text-center">
      <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
      <div class="alert-actions">
        <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
      </div>
    </div>
  </ng-template>